<template>
	<div class="location-link-container" :class="style()">
		<mq-layout mq="desktop">
			<router-link :to="getRoute()">
				<img v-if="!isInjectable()" alt="store logo image" class="logo" src="../../assets/store-logo.png" width="168" aria-label="store home" />
			</router-link>
			<service-type-info />
		</mq-layout>
		<mq-layout :mq="['mobile', 'tablet']">
			<div class="destination-description">
				<div class="location-link-wrapper">
					<a class="location-link" @click="setModal('locations')" aria-label="store locations page">
						{{location.name}}
					</a>
				</div>
			</div>
		</mq-layout>
	</div>
</template>

<script>
import { EServiceType } from '@/models/interfaces/Orders/EServiceType';
import { LOCATION, ACCOUNT_CHECKOUT, APP_STORE } from '@/stores/defs';
import { mapGetters, mapActions } from 'vuex';
import DateManipulator from '@/utils/DateManipulator';
import modalMixin from '@/components/mixins/modalMixin';
import layoutMixin from '@/components/mixins/layoutMixin';
import ServiceTypeInfo from '@/components/header/ServiceTypeInfo.vue';
import StoreLocator from '@/components/store-locator/StoreLocator/StoreLocator.vue';
import * as moment from 'moment';
// TODO cleanup too much duplicated code between this and ServiceTypeInfo
export default {
    mixins: [
		modalMixin,
		layoutMixin,
	],
    components: {
        'service-type-info': ServiceTypeInfo
    },
    computed: {
        ...mapGetters({
            serviceType: ACCOUNT_CHECKOUT.GET_SERVICE_TYPE,
            location: LOCATION.GET_LOCATION,
            orderTime: ACCOUNT_CHECKOUT.GET_ORDER_TIME,
            isDebug: APP_STORE.GET_DEBUG
        }),
        getOrderTime(time) {
            if (DateManipulator.isTimeASAP(this.orderTime)) {
                return 'ASAP';
            } else {
                const dateFormat = DateManipulator.isMomentToday(this.orderTime) ? 'hh:mma' : 'MMM/DD/YYYY hh:mma';
                return moment(this.orderTime).format(dateFormat);
            }
        }
    },
    data() {
        return {
            EServiceType: EServiceType
        };
    },
    methods: {
        getRoute() {
            return {
                path: '/',
                ...(this.isDebug && { query: { debug: 1 } })
            };
        },
        isInjectable() {
            return this.$route.name === 'injectable-header';
        },
        serviceTypeName() {
            return this.serviceType === EServiceType.SERVICE_TYPE_TAKEOUT ? 'Pickup' : 'Delivery';
        },
        setModal(modalType) {
            let title, component;
            if (modalType === 'locations') {
                component = StoreLocator;
                title = 'Locations';
            }
            this.triggerModal({
                component: component,
                classes: 'global-modal',
                title: title
            });
		},
		style() {
			return {
				sidebar: this.layout_hasSidebar,
			};
		}
	},
};
</script>

<style lang="scss" scoped>
@import 'globalStyles';

.location-link-wrapper {
	width: 52vw;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    a {
        &.location-link {
			color: $navigationItemColor;
			font-weight: bold;
        }
    }
}

.logo {
	max-height: 2em;
	object-fit: contain;
}
.sidebar {
	.logo {
		max-height: 6em;
	}
}

@include mobile {
    .location-link-wrapper {
		margin: 0 0 0 0;
		text-align: center;
        a {
            font-size: 14px;
			font-size: 0.9rem;
			line-height: 2.3em;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationLocationMobile.vue